import React, { useState, useEffect } from "react";

function About() {
  const [text, setText] = useState("");
  const fullText = "Hi !\nI am Ishan Karunaratne";
  const [index, setIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    const handleIntersection = (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting && !isTyping) {
        setIsTyping(true);
        setIndex(0);
        setText("");
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    });

    const aboutSection = document.getElementById("about");
    if (aboutSection) {
      observer.observe(aboutSection);
    }

    return () => {
      if (aboutSection) {
        observer.unobserve(aboutSection);
      }
    };
  }, [isTyping]);

  useEffect(() => {
    if (isTyping && index < fullText.length) {
      const timeout = setTimeout(() => {
        setText((prev) => prev + fullText[index]);
        setIndex((prev) => prev + 1);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [index, isTyping]);

  return (
    <div className="about text-white d-flex align-items-center" id="about">
      <div className="container h-100">
        <div className="row align-items-center justify-content-around">
          <div className="col-md-4 d-flex align-items-center m-b-30 justify-content-center">
            <div className="flip-image">
              <div className="flip-image-inner">
                <div className="flip-image-front">
                  <img
                    src="/assets/images/intro-2.jpg"
                    alt=""
                    className="about-photo"
                  />
                </div>
                <div className="flip-image-back">
                  <img
                    src="/assets/images/intro.png"
                    alt=""
                    className="about-photo"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-7">
            <h4 className="m-b-30">
              {text.split("\n").map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </h4>
            <p className="lead height-lg">
              I am an Experienced Software Engineer with a strong background in
              designing and implementing scalable solutions. Proficient in
              multiple programming languages and frameworks, adept at
              collaborating with cross-functional teams to deliver high-quality
              software products. Passionate about staying updated with emerging
              technologies and leveraging them to drive innovation in software
              development.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
